
export default {
  name: 'AppReviewOptions',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    reviewOptionsType: {
      type: String,
      default: 'user-property',
      validator: v => ['user-property', 'evaluation'].includes(v)
    },
    isMobileStyleForced: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showOptions() {
      return this.options?.length > 0;
    }
  }
};
